// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zmFGJHloGAYiiJqFzxOU {
	background: #edf1f8;
	border-radius: 12px;

	display: grid;

	grid-template-areas: 'header details' 'assets details';
	grid-template-rows: 60px auto;
}
@media (max-width: 767px) {
.zmFGJHloGAYiiJqFzxOU {
		grid-template: 'header' 'assets' 'details';
		grid-template-rows: none;
}
	}
.q0pwHNUNLhEQnQTM2f22 {
	cursor: pointer;
}
.q0pwHNUNLhEQnQTM2f22:hover {
		background: #e6e7f1;
	}
.foN8z7oMzRZLenSBi_uY {
	padding: 20px 16px 12px 24px;
	grid-area: header;
}
@media (max-width: 767px) {
.foN8z7oMzRZLenSBi_uY {
		padding: 20px 24px 6px 24px;
}
	}
.tWnnZFd5Z48pPiFdqoKk {
	grid-area: assets;
	padding: 12px 16px 28px 24px;
	display: flex;
	gap: 16px;
	height: 86px;
}
@media (max-width: 767px) {
.tWnnZFd5Z48pPiFdqoKk {
		height: 56px;
		padding: 6px 24px;
}
	}
.weN90NGqf9_hFmYVeTj9 {
	background-color: white;
	border-radius: 8px;
	height: 44px;
}
.xLUnD4ySGVAVJJh9CrVr {
	grid-area: details;
}
.VTnyylJJCrVIGkA0lzdU:first-child {
		padding-top: 16px;
	}
.VTnyylJJCrVIGkA0lzdU {
	padding: 8px 24px 8px 0;
}
.VTnyylJJCrVIGkA0lzdU:last-child {
		padding-bottom: 16px;
	}
@media (max-width: 767px) {
.VTnyylJJCrVIGkA0lzdU {
		padding-left: 24px;
}
	}
.HfyERtU2P9jE1IztSDk6,
.ckYl8_2TxkWXEZkvohdL {
	text-align: right;
	white-space: nowrap;
}
@media (max-width: 767px) {
.HfyERtU2P9jE1IztSDk6,
.ckYl8_2TxkWXEZkvohdL {
		text-align: left;
}
	}
.HfyERtU2P9jE1IztSDk6 {
	line-height: 20px;
	font-size: 12px;
}
.ckYl8_2TxkWXEZkvohdL {
	line-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/TokenPairCard/TokenPairCard.pcss"],"names":[],"mappings":"AAEA;CACC,mBAAmB;CACnB,mBAAmB;;CAEnB,aAAa;;CAEb,sDAAsD;CACtD,6BAA6B;AAM9B;AAJC;AATD;EAUE,0CAA0C;EAC1C,wBAAwB;AAE1B;CADC;AAGD;CACC,eAAe;AAKhB;AAHC;EACC,mBAAmB;CACpB;AAGD;CACC,4BAA4B;CAC5B,iBAAiB;AAIlB;AAHC;AAHD;EAIE,2BAA2B;AAE7B;CADC;AAED;CACC,iBAAiB;CACjB,4BAA4B;CAC5B,aAAa;CACb,SAAS;CACT,YAAY;AAKb;AAJC;AAND;EAOE,YAAY;EACZ,iBAAiB;AAEnB;CADC;AAGD;CACC,uBAAuB;CACvB,kBAAkB;CAClB,YAAY;AACb;AAEA;CACC,kBAAkB;AACnB;AAEC;EACC,iBAAiB;CAClB;AAHD;CAIC,uBAAuB;AAOxB;AANC;EACC,oBAAoB;CACrB;AACA;AARD;EASE,kBAAkB;AAEpB;CADC;AAGD;;CAEC,iBAAiB;CACjB,mBAAmB;AAIpB;AAHC;AAJD;;EAKE,gBAAgB;AAElB;CADC;AAGD;CACC,iBAAiB;CACjB,eAAe;AAChB;AAEA;CACC,iBAAiB;AAClB","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.card {\n\tbackground: #edf1f8;\n\tborder-radius: 12px;\n\n\tdisplay: grid;\n\n\tgrid-template-areas: 'header details' 'assets details';\n\tgrid-template-rows: 60px auto;\n\n\t@media (--mobile) {\n\t\tgrid-template: 'header' 'assets' 'details';\n\t\tgrid-template-rows: none;\n\t}\n}\n\n.hasOnClick {\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground: #e6e7f1;\n\t}\n}\n\n.header {\n\tpadding: 20px 16px 12px 24px;\n\tgrid-area: header;\n\t@media (--mobile) {\n\t\tpadding: 20px 24px 6px 24px;\n\t}\n}\n.assets {\n\tgrid-area: assets;\n\tpadding: 12px 16px 28px 24px;\n\tdisplay: flex;\n\tgap: 16px;\n\theight: 86px;\n\t@media (--mobile) {\n\t\theight: 56px;\n\t\tpadding: 6px 24px;\n\t}\n}\n\n.asset {\n\tbackground-color: white;\n\tborder-radius: 8px;\n\theight: 44px;\n}\n\n.details {\n\tgrid-area: details;\n}\n.detail {\n\t&:first-child {\n\t\tpadding-top: 16px;\n\t}\n\tpadding: 8px 24px 8px 0;\n\t&:last-child {\n\t\tpadding-bottom: 16px;\n\t}\n\t@media (--mobile) {\n\t\tpadding-left: 24px;\n\t}\n}\n\n.label,\n.value {\n\ttext-align: right;\n\twhite-space: nowrap;\n\t@media (--mobile) {\n\t\ttext-align: left;\n\t}\n}\n\n.label {\n\tline-height: 20px;\n\tfont-size: 12px;\n}\n\n.value {\n\tline-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `zmFGJHloGAYiiJqFzxOU`,
	"hasOnClick": `q0pwHNUNLhEQnQTM2f22`,
	"header": `foN8z7oMzRZLenSBi_uY`,
	"assets": `tWnnZFd5Z48pPiFdqoKk`,
	"asset": `weN90NGqf9_hFmYVeTj9`,
	"details": `xLUnD4ySGVAVJJh9CrVr`,
	"detail": `VTnyylJJCrVIGkA0lzdU`,
	"label": `HfyERtU2P9jE1IztSDk6`,
	"value": `ckYl8_2TxkWXEZkvohdL`
};
export default ___CSS_LOADER_EXPORT___;
